export default __webpack_public_path__ + "static/sovryn-7715383b33253ffa345e842c220c3198.svg";